import { normalizeStoragePath } from 'domain/shared/documentStorage';
import { DEFAULT_ERROR_MESSAGE } from 'framework/form';

const loadCurrentDocumentMarkdown = async ({
  currentDocumentPath,
  getDocumentToken,
}: {
  currentDocumentPath: string;
  getDocumentToken: (path: string) => Promise<string>;
}): Promise<{ content: string }> => {
  const token = await getDocumentToken(normalizeStoragePath(currentDocumentPath));
  const response = await fetch(token);

  if (!response.ok) {
    throw new Error(DEFAULT_ERROR_MESSAGE);
  }

  const text = await response.text();
  return {
    content: text,
  };
};

export default loadCurrentDocumentMarkdown;
